<template>
  <v-dialog v-model="visible" max-width="325px" v-click-outside="close">
    <v-card>
      <v-card-title class="title font-weight-regular justify-center">
        <span class="call--title">{{ title }}</span>
      </v-card-title>

      <div class="pa-3">
        <user-avatar 
          :avatar="avatar"
          :username="username" 
          :size="192"
        />

        <v-card-title class="title font-weight-regular justify-center">
          <span>{{ username }}</span>
        </v-card-title>

      </div>

      <v-card-actions style="padding-bottom:16px;">
        <v-spacer></v-spacer>
        <v-btn color="green" large icon @click="accept" v-if="canAccept">
          <v-icon>call</v-icon>
        </v-btn>

        <v-btn color="red" large icon @click="decline">
          <v-icon>call_end</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<style>
  .call--title::first-letter {
    text-transform:capitalize;
  }
</style>

<script>
  import UserAvatar from '@common/UserAvatar.vue'

  export default {
    name: 'calling-dialog',
    data: () => ({
      title: '',
      username: '',
      avatar: '',
    }),
    components: {
      UserAvatar
    },
    props: {
      visible: {
        type: Boolean, 
        default: false
      }
    },
    /*mounted() {
      const t = this.$store.state.callDirection == 0 
        ? this.$t('incoming_call_title') 
        : this.$t('outgoing_call_title')
      this.title = t.toLowerCase()
    },*/
    computed: {
      canAccept() {
        return this.$store.getters.isCallIncoming
      }
    },
    methods: {
      close() {
        if (!this.visible)
          return
        // notify parent
        this.$emit('update:visible', false)
      },
      accept() {
        this.$store.dispatch('acceptCall').then(() => {
          this.close()
        })
      },
      decline() {
        this.$store.dispatch('declineCall').then(() => {
          this.close()
        })
      },
      setCallerId(contactId) {
        if (contactId === '#1') {
          this.username = this.$t('contacts_echo')
          this.avatar = ''
        } else {
          const con = this.$store.state.contacts.find(c => c.contactId == contactId)
          this.username = (con && con.name !== '') ? con.name : contactId
          this.avatar   = (con && con.avatar !== '') ? con.avatar : ''
        }
      }
    },
    watch: {
      visible: function(newValue, oldValue) {
        if (newValue) {
          console.log('-- calling visible changed')
          const t = this.$store.state.callDirection == 0 
            ? this.$t('incoming_call_title') 
            : this.$t('outgoing_call_title')
          this.title = t.toLowerCase()
        }
      }
    }
  }
</script>